/**
 * Stated-precision rounding (2026-08-13, Redhead hold RCA) — "3 km" carries
 * zero decimals, so it CLAIMS one-significant-figure precision; the governed
 * 2.9 km rounds to exactly 3 at that precision, which makes the prose honest
 * rounding, not a substituted value. The golden counter-case stays blocked:
 * "3.0 km" claims one-decimal precision, and 5.2 does not round to 3.0.
 *
 * The precision comes from the PROSE ITSELF — no tolerance knob to loosen.
 */
export function roundsToStatedPrecision(rawNumeric: string, governed: number): boolean {
  const cleaned = rawNumeric.replace(/,/g, '').trim();
  const token = Number(cleaned);
  if (!Number.isFinite(token) || !Number.isFinite(governed)) return false;
  const decimals = (cleaned.split('.')[1] ?? '').length;
  const factor = 10 ** decimals;
  return Math.round(governed * factor) / factor === token;
}

/** Extract the numeric part of a raw prose token ("3 km" → "3"). */
export function numericPartOf(rawToken: string): string | null {
  return rawToken.match(/-?[\d,]+(?:\.\d+)?/)?.[0] ?? null;
}
